// Loguea el desglose de coste de un cuento en la consola del navegador
// con estilos CSS para que se lea claro y bonito.
//
//   logCostBreakdown(titulo, costBreakdown)
//
// costBreakdown = { lines: [{label, model, inputTokens, outputTokens, totalTokens, usd, eur}], totalTokens, totalUsd, totalEur, elapsedSeconds }

const STYLES = {
  banner:
    'background:linear-gradient(90deg,#a855f7,#7e22ce);color:white;font-weight:bold;padding:4px 12px;border-radius:6px;font-size:13px;',
  subtitle: 'color:#7e22ce;font-weight:600;font-size:12px;',
  muted: 'color:#888;font-style:italic;',
  total: 'color:#7e22ce;font-weight:bold;font-size:12px;',
};

const seen = new Set(); // evita logear varias veces el mismo cuento

function detailFor(line) {
  if (line.seconds != null) return `${line.seconds}s audio`;
  if (line.chars != null) return `${line.chars} chars`;
  return '';
}

export function logCostBreakdown(title, cost) {
  if (!cost || !Array.isArray(cost.lines)) return;
  const key = `${title}|${cost.totalUsd}|${cost.totalTokens}`;
  if (seen.has(key)) return;
  seen.add(key);

  console.groupCollapsed(
    '%c📚 Coste de "%s"%c   %s tokens · $%s · €%s · %ss',
    STYLES.banner,
    title,
    STYLES.muted,
    cost.totalTokens,
    cost.totalUsd.toFixed(5),
    cost.totalEur.toFixed(5),
    (cost.elapsedSeconds ?? 0).toFixed(1)
  );

  const table = cost.lines.map((l) => ({
    Paso: l.label,
    Modelo: l.model,
    'Tokens entrada': l.inputTokens || '',
    'Tokens salida': l.outputTokens || '',
    'Tokens total': l.totalTokens || '',
    Detalle: detailFor(l),
    USD: `$${l.usd.toFixed(5)}`,
    EUR: `€${l.eur.toFixed(5)}`,
  }));
  table.push({
    Paso: '— TOTAL —',
    Modelo: '',
    'Tokens entrada': '',
    'Tokens salida': '',
    'Tokens total': cost.totalTokens,
    Detalle: '',
    USD: `$${cost.totalUsd.toFixed(5)}`,
    EUR: `€${cost.totalEur.toFixed(5)}`,
  });

  // eslint-disable-next-line no-console
  console.table(table);
  console.log(
    '%cTotal: %c$%s · €%s   (%s tokens en %ss)',
    STYLES.subtitle,
    STYLES.total,
    cost.totalUsd.toFixed(5),
    cost.totalEur.toFixed(5),
    cost.totalTokens,
    (cost.elapsedSeconds ?? 0).toFixed(1)
  );
  console.groupEnd();
}
